export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: false,
};

export const PageName = '资金划转记录列表';
